import React, { Dispatch, SetStateAction } from "react";
import InsightFiltersViewModel from "../../ViewModels/InsightFiltersViewModel";
import SelectFilterContainer from "../GenericFilters/Select/SelectFilterContainer";

interface IScheduleFilterContainerProps {
    filters: InsightFiltersViewModel
    setFilters: Dispatch<SetStateAction<InsightFiltersViewModel>>
}

export default function ScheduleFilterContainer({ filters, setFilters }: IScheduleFilterContainerProps) {
    const options = ['Scheduled', 'Manual'];

    return (
        <>
            <SelectFilterContainer
                filters={filters}
                setFilters={setFilters}
                name='schedule'
                label='Schedule'
                options={options} />
        </>
    );
};
